import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const AppBarHeader = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.container}>{children}</div>;
};
